import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import TabContainer from './applications/TabContainer';
import TransactionsContainer from './dashboard/TransactionsContainer';
import SettingsContainer from './settings/SettingsContainer';

function HealthCertificateContainer({ match }) {
  const permissions = getJson('permissions');
  return (
    <div className="module-inner">
      <div className="module-inner-title">Health Certificate</div>
      <div className="generic-module-nav mb-3">
        {Acl(permissions, ['VIEW HEALTH CERTIFICATE DASHBOARD']) && (
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/health-certificate"
          >
            Dashboard
          </NavLink>
        )}
        {Acl(permissions, ['VIEW HEALTH CERTIFICATE TRANSACTIONS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/health-certificate/application"
          >
            Applications
          </NavLink>
        )}
        <NavLink
          exact={false}
          className="nav-link"
          activeClassName="active"
          to="/health-certificate/settings"
        >
          Settings
        </NavLink>
      </div>
      <Switch>
        <Route exact path={`${match.path}`} component={TransactionsContainer} />
        <Route path={`${match.path}/application`} component={TabContainer} />
        <Route path={`${match.path}/settings`} component={SettingsContainer} />
      </Switch>
    </div>
  );
}

HealthCertificateContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(HealthCertificateContainer);
